module.exports = __webpack_public_path__ + "img/3_102.ca9c4ddb.png";